export default "__VITE_ASSET__BbuBuUR1__"